import React, { memo } from 'react';
import './Message.css';

const Message = memo(({ type, children, className = '' }) => {
  return (
    <div className={`message message-${type} ${className}`}>
      {children}
    </div>
  );
});

Message.displayName = 'Message';

export default Message;
